import RecibosEmail, { BotaoEmailRecibo } from '../components/RecibosEmail';
import Trabalhadores from './Trabalhadores';
import { useSearchParams } from 'react-router-dom';
import './RecursosHumanos.css';
import LiquidText from '../components/LiquidText';
import DeleteIcon from '../components/DeleteIcon';
import { useLiquidFeedback, LiquidDialog } from '../components/LiquidUI';
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import api from '../services/api';
import { useAvisoVencimentos } from '../context/AvisoVencimentosContext';
import { createPortal } from 'react-dom';
import { useAuth } from '../context/AuthContext';

// Vencimentos: escritório pela ordem que o Tiago definiu (Ana Rita, Artur, Ilídio,
// Maria da Glória, Matilde); a seguir vem a obra, com o José Manuel Tripa (10) à cabeça.
const ORDEM_ESCRITORIO_VENC = [35, 11, 19, 37, 36];

/* ============================================================
   RECURSOS HUMANOS — Mapa de Férias
   Mapa anual/mensal de férias e ausências por trabalhador.
   ============================================================ */

const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const MESES_CURTO = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

const TIPOS = {
    ferias: { label: 'Férias', cor: '#22c55e', bg: '#dcfce7', fg: '#166534' },
    falta: { label: 'Falta', cor: '#ef4444', bg: '#fee2e2', fg: '#991b1b' },
    baixa: { label: 'Baixa médica', cor: '#f97316', bg: '#ffedd5', fg: '#9a3412' },
    outro: { label: 'Outro', cor: '#64748b', bg: '#f1f5f9', fg: '#475569' },
};

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const soData = (v) => String(v || '').substring(0, 10);
const diasNoMes = (ano, mes) => new Date(ano, mes + 1, 0).getDate();
const ehFimSemana = (ano, mes, dia) => { const d = new Date(ano, mes, dia).getDay(); return d === 0 || d === 6; };
const fmtData = (v) => { const s = soData(v); if (!s) return '—'; const [a, m, d] = s.split('-'); return `${d}/${m}/${a}`; };

// Dias úteis de um período dentro do ano (não conta fins de semana)
const diasUteis = (inicio, fim, ano) => {
    let n = 0;
    const ini = new Date(Math.max(new Date(soData(inicio)), new Date(`${ano}-01-01`)));
    const f = new Date(Math.min(new Date(soData(fim)), new Date(`${ano}-12-31`)));
    for (let d = new Date(ini); d <= f; d.setDate(d.getDate() + 1)) {
        const dw = d.getDay();
        if (dw !== 0 && dw !== 6) n++;
    }
    return n;
};

/* ---------- Modal de período ---------- */
function PeriodoModal({ registo, trabalhadores, preSelecao, onClose, onSaved }) {
    const liquidFeedback = useLiquidFeedback();
    const novo = !registo;
    const [form, setForm] = useState(() => novo ? {
        trabalhador_id: preSelecao?.trabalhador_id || '',
        data_inicio: preSelecao?.data || '',
        data_fim: preSelecao?.data || '',
        tipo: 'ferias', estado: 'aprovada', observacoes: '',
    } : {
        trabalhador_id: registo.trabalhador_id,
        data_inicio: soData(registo.data_inicio),
        data_fim: soData(registo.data_fim),
        tipo: registo.tipo || 'ferias',
        estado: registo.estado || 'aprovada',
        observacoes: registo.observacoes || '',
    });
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState('');
    const upd = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

    const guardar = async () => {
        setSaving(true); setErr('');
        try {
            if (novo) await api.post('/rh/ferias', form);
            else await api.put(`/rh/ferias/${registo.id}`, form);
            onSaved(); onClose();
        } catch (e) { setErr(e.response?.data?.error || 'Erro ao guardar'); }
        finally { setSaving(false); }
    };

    const eliminar = async () => {
        if (!await liquidFeedback.confirm('Eliminar este período?')) return;
        try { await api.delete(`/rh/ferias/${registo.id}`); onSaved(); onClose(); }
        catch { liquidFeedback.notify('Erro ao eliminar'); }
    };

    return (
        <LiquidDialog onClose={onClose} style={overlay} onClick={onClose}>
            <div style={{ ...modal, maxWidth: 520 }} onClick={e => e.stopPropagation()}>
                <div style={modalHead}>
                    <h3 style={{ margin: 0 }}>{novo ? 'Novo período' : 'Editar período'}</h3>
                    <button onClick={onClose} style={closeBtn}><LiquidText>✕</LiquidText></button>
                </div>
                <div style={{ marginBottom: 10 }}>
                    <label data-liquid-label="true" style={lbl}>Trabalhador *</label>
                    <select value={form.trabalhador_id} onChange={e => upd('trabalhador_id', e.target.value)} style={{ ...inp, width: '100%' }}>
                        <option value="">Selecione…</option>
                        {trabalhadores.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                    </select>
                </div>
                <div data-liquid-grid="true" style={grid2}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Início *</label>
                        <input type="date" value={form.data_inicio} onChange={e => upd('data_inicio', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Fim *</label>
                        <input type="date" value={form.data_fim} onChange={e => upd('data_fim', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                </div>
                <div data-liquid-grid="true" style={grid2}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Tipo</label>
                        <select value={form.tipo} onChange={e => upd('tipo', e.target.value)} style={{ ...inp, width: '100%' }}>
                            {Object.entries(TIPOS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                        </select>
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Estado</label>
                        <select value={form.estado} onChange={e => upd('estado', e.target.value)} style={{ ...inp, width: '100%' }}>
                            <option value="aprovada">Aprovada</option>
                            <option value="planeada">Planeada</option>
                        </select>
                    </div>
                </div>
                <div style={{ marginBottom: 6 }}>
                    <label data-liquid-label="true" style={lbl}>Observações</label>
                    <textarea rows={2} value={form.observacoes} onChange={e => upd('observacoes', e.target.value)} style={{ ...inp, width: '100%', resize: 'vertical' }} />
                </div>
                {form.data_inicio && form.data_fim && (
                    <div style={{ fontSize: '0.82rem', color: '#64748b' }}>
                        {diasUteis(form.data_inicio, form.data_fim, new Date(form.data_inicio).getFullYear())} dia(s) útil(eis)
                    </div>
                )}
                {err && <div style={{ color: '#e53e3e', margin: '10px 0', fontSize: '0.85rem' }}>{err}</div>}
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginTop: 14 }}>
                    {novo ? <span /> : <button onClick={eliminar} style={{ ...btnSec, color: '#dc2626', borderColor: '#fca5a5' }}><DeleteIcon /> Eliminar</button>}
                    <div data-liquid-actions="true" style={{ display: 'flex', gap: 8 }}>
                        <button onClick={onClose} style={btnSec}>Cancelar</button>
                        <button data-liquid-primary="true" onClick={guardar} disabled={saving} style={{ ...btnPri, opacity: saving ? 0.6 : 1 }}>{saving ? 'A guardar…' : 'Guardar'}</button>
                    </div>
                </div>
            </div>
        </LiquidDialog>
    );
}

/* ---------- Página ---------- */
const RecursosHumanos = ({ filtrosDestino, acoesDestino }) => {
    const liquidFeedback = useLiquidFeedback();
    const anoAtual = new Date().getFullYear();
    const [ano, setAno] = useState(anoAtual);
    const [vista, setVista] = useState('ano'); // ano | mes
    const [mes, setMes] = useState(new Date().getMonth());
    const [dados, setDados] = useState({ trabalhadores: [], ausencias: [] });
    const [loading, setLoading] = useState(true);
    const [pesquisa, setPesquisa] = useState('');
    const [editar, setEditar] = useState(null); // { registo } | { preSelecao }

    // silencioso = true: recarrega sem esconder a tabela (usado nos cliques rápidos nas células)
    const carregar = useCallback(async (silencioso = false) => {
        if (!silencioso) setLoading(true);
        try {
            const r = await api.get('/rh/ferias', { params: { ano, _t: Date.now() } });
            setDados({ trabalhadores: r.data.trabalhadores || [], ausencias: r.data.ausencias || [] });
        } catch (e) { console.error(e); }
        finally { if (!silencioso) setLoading(false); }
    }, [ano]);
    useEffect(() => { carregar(); }, [carregar]);

    // Clique num dia: vazio -> férias; com marcação de um só dia -> roda o tipo
    // (férias -> falta -> baixa -> outro -> limpa). Períodos de vários dias abrem
    // a edição, para um clique distraído não mudar uma semana inteira.
    const ORDEM = ['ferias', 'falta', 'baixa', 'outro'];
    const ocupadas = useRef(new Set()); // células com pedido em curso (evita duplo clique)
    const clicarDia = async (trab, data) => {
        const chave = `${trab.id}|${data}`;
        if (ocupadas.current.has(chave)) return;
        const a = porDia.get(chave);
        if (a && soData(a.data_inicio) !== soData(a.data_fim)) { setEditar({ registo: a }); return; }
        ocupadas.current.add(chave);
        try {
            if (!a) {
                await api.post('/rh/ferias', { trabalhador_id: trab.id, data_inicio: data, data_fim: data, tipo: 'ferias', estado: 'aprovada', observacoes: '' });
            } else {
                const prox = ORDEM[ORDEM.indexOf(a.tipo) + 1];
                if (prox) {
                    await api.put(`/rh/ferias/${a.id}`, {
                        trabalhador_id: a.trabalhador_id, data_inicio: soData(a.data_inicio), data_fim: soData(a.data_fim),
                        tipo: prox, estado: a.estado || 'aprovada', observacoes: a.observacoes || '',
                    });
                } else {
                    await api.delete(`/rh/ferias/${a.id}`);
                }
            }
            await carregar(true);
        } catch (e) {
            liquidFeedback.notify(e.response?.data?.error || 'Erro ao guardar a marcação');
        } finally {
            ocupadas.current.delete(chave);
        }
    };

    const anos = [];
    for (let a = anoAtual + 1; a >= anoAtual - 3; a--) anos.push(a);

    // Índice: trabalhador -> data ISO -> ausência (para pintar as células)
    const porDia = useMemo(() => {
        const m = new Map();
        dados.ausencias.forEach(a => {
            const ini = new Date(soData(a.data_inicio));
            const fim = new Date(soData(a.data_fim));
            for (let d = new Date(ini); d <= fim; d.setDate(d.getDate() + 1)) {
                if (d.getFullYear() !== ano) continue;
                const chave = `${a.trabalhador_id}|${iso(d)}`;
                if (!m.has(chave)) m.set(chave, a);
            }
        });
        return m;
    }, [dados.ausencias, ano]);

    const trabalhadores = pesquisa.trim()
        ? dados.trabalhadores.filter(t => (t.nome || '').toLowerCase().includes(pesquisa.trim().toLowerCase()))
        : dados.trabalhadores;

    // Totais por trabalhador (dias úteis de férias no ano)
    const totalFerias = (trabId) => dados.ausencias
        .filter(a => a.trabalhador_id === trabId && a.tipo === 'ferias')
        .reduce((acc, a) => acc + diasUteis(a.data_inicio, a.data_fim, ano), 0);

    const celula = (trab, mesIdx, dia) => {
        const chave = `${trab.id}|${ano}-${String(mesIdx + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
        const a = porDia.get(chave);
        const fds = ehFimSemana(ano, mesIdx, dia);
        const cor = a ? TIPOS[a.tipo]?.cor || TIPOS.outro.cor : (fds ? '#f1f5f9' : '#fff');
        return (
            <td key={dia}
                onClick={() => clicarDia(trab, `${ano}-${String(mesIdx + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`)}
                title={a ? `${TIPOS[a.tipo]?.label}: ${fmtData(a.data_inicio)} a ${fmtData(a.data_fim)}${a.observacoes ? ' — ' + a.observacoes : ''} — clique para mudar` : 'Clique para marcar férias'}
                style={{
                    background: cor, border: '1px solid #e2e8f0', width: 22, minWidth: 22, height: 26,
                    cursor: 'pointer', padding: 0,
                    opacity: a && a.estado === 'planeada' ? 0.55 : 1,
                }} />
        );
    };

    return (
        <div className="page-content" style={{ padding: 24 }}>
            {filtrosDestino && createPortal(<div className="rh-filtros-comuns"><div>
                        <label data-liquid-label="true" style={lbl}>Ano</label>
                        <select value={ano} onChange={e => setAno(parseInt(e.target.value, 10))} style={inp}>
                            {anos.map(a => <option key={a} value={a}>{a}</option>)}
                        </select>
                    </div>
<div>
                        <label data-liquid-label="true" style={lbl}>Vista</label>
                        <div style={{ display: 'flex', gap: 6 }}>
                            <button aria-pressed={vista === 'ano'} onClick={() => setVista('ano')} style={{ ...btnSec, ...(vista === 'ano' ? btnAtivo : {}) }}>Ano</button>
                            <button aria-pressed={vista === 'mes'} onClick={() => setVista('mes')} style={{ ...btnSec, ...(vista === 'mes' ? btnAtivo : {}) }}>Mês</button>
                        </div>
                    </div>
{vista === 'mes' && (
                        <div>
                            <label data-liquid-label="true" style={lbl}>Mês</label>
                            <select value={mes} onChange={e => setMes(parseInt(e.target.value, 10))} style={inp}>
                                {MESES.map((m, i) => <option key={m} value={i}>{m}</option>)}
                            </select>
                        </div>
                    )}</div>, filtrosDestino)}
{acoesDestino && createPortal(<div className="rh-acoes-comuns"><button data-liquid-primary="true" onClick={() => setEditar({ preSelecao: {} })} style={btnPri}>+ Novo período</button>
<div>
                        
                        <input value={pesquisa} onChange={e => setPesquisa(e.target.value)} aria-label="Pesquisa por nome de colaborador" placeholder="Pesquisa por nome de colaborador" style={{ ...inp, width: 200 }} />
                    </div></div>, acoesDestino)}

            {/* Legenda */}
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 14, alignItems: 'center' }}>
                {Object.entries(TIPOS).map(([k, v]) => (
                    <span key={k} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: '0.82rem', color: '#475569' }}>
                        <span style={{ width: 14, height: 14, background: v.cor, borderRadius: 3, display: 'inline-block' }} /> <LiquidText>{v.label}</LiquidText>
                    </span>
                ))}
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: '0.82rem', color: '#475569' }}>
                    <span style={{ width: 14, height: 14, background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 3, display: 'inline-block' }} /> Fim de semana
                </span>
                <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>· Clique no nome para marcar um período · clique num dia para marcar férias e volte a clicar para mudar (férias → falta → baixa → outro → limpar) · períodos de vários dias abrem a edição · "planeados" aparecem esbatidos</span>
            </div>

            {loading ? <p style={{ color: '#718096' }}>A carregar…</p>
                : trabalhadores.length === 0 ? (
                    <div style={{ padding: '48px 0', textAlign: 'center', color: '#94a3b8' }}>Sem trabalhadores ativos para mostrar.</div>
                ) : vista === 'mes' ? (
                    /* ---- Vista mensal: dias 1..31 ---- */
                    <div data-liquid-surface="true" className="table-responsive" style={{ background: '#fff', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto' }}>
                        <table data-liquid-calendar="true" style={{ borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                            <thead>
                                <tr>
                                    <th style={{ ...thSticky, minWidth: 200 }}>Trabalhador</th>
                                    {Array.from({ length: diasNoMes(ano, mes) }, (_, i) => i + 1).map(d => (
                                        <th key={d} style={{ width: 22, minWidth: 22, padding: 2, textAlign: 'center', color: ehFimSemana(ano, mes, d) ? '#94a3b8' : '#475569', fontSize: '0.7rem', borderBottom: '1px solid #e2e8f0' }}>{d}</th>
                                    ))}
                                    <th style={{ padding: '4px 8px', fontSize: '0.72rem', color: '#475569', borderBottom: '1px solid #e2e8f0', whiteSpace: 'nowrap' }}>Férias ano</th>
                                </tr>
                            </thead>
                            <tbody>
                                {trabalhadores.map(t => (
                                    <tr key={t.id}>
                                        <td style={{ ...tdSticky, minWidth: 200, cursor: 'pointer' }} title="Clique para marcar um período"
                                            onClick={() => setEditar({ preSelecao: { trabalhador_id: t.id } })}>
                                            {t.nome}
                                            {t.ativo === false && <span style={{ color: '#b45309', fontSize: '0.7rem', marginLeft: 6 }} title={`Saiu em ${fmtData(t.inativo_em)}`}>· saiu</span>}
                                        </td>
                                        {Array.from({ length: diasNoMes(ano, mes) }, (_, i) => i + 1).map(d => celula(t, mes, d))}
                                        <td style={{ textAlign: 'center', fontWeight: 700, color: '#166534', padding: '0 8px' }}>{totalFerias(t.id) || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    /* ---- Vista anual: 12 meses × dias ---- */
                    <div data-liquid-surface="true" className="table-responsive" style={{ background: '#fff', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto' }}>
                        <table data-liquid-calendar="true" style={{ borderCollapse: 'collapse', fontSize: '0.75rem' }}>
                            <thead>
                                <tr>
                                    <th style={{ ...thSticky, minWidth: 180 }} rowSpan={2}>Trabalhador</th>
                                    {MESES_CURTO.map((m, i) => (
                                        <th key={m} colSpan={diasNoMes(ano, i)} style={{ padding: '3px 0', textAlign: 'center', fontSize: '0.72rem', color: '#334155', borderLeft: '2px solid #cbd5e1', borderBottom: '1px solid #e2e8f0' }}>{m}</th>
                                    ))}
                                    <th style={{ padding: '4px 8px', fontSize: '0.7rem', color: '#475569', borderLeft: '2px solid #cbd5e1', borderBottom: '1px solid #e2e8f0', whiteSpace: 'nowrap' }} rowSpan={2}>Férias</th>
                                </tr>
                                <tr>
                                    {MESES_CURTO.map((m, i) => Array.from({ length: diasNoMes(ano, i) }, (_, d) => (
                                        <th key={`${m}-${d}`} style={{ width: 10, minWidth: 10, padding: 0, fontSize: '0.55rem', color: '#cbd5e1', borderLeft: d === 0 ? '2px solid #cbd5e1' : 'none', borderBottom: '1px solid #e2e8f0' }}>
                                            {(d + 1) % 5 === 0 ? d + 1 : ''}
                                        </th>
                                    )))}
                                </tr>
                            </thead>
                            <tbody>
                                {trabalhadores.map(t => (
                                    <tr key={t.id}>
                                        <td style={{ ...tdSticky, minWidth: 180, cursor: 'pointer' }} title="Clique para marcar um período"
                                            onClick={() => setEditar({ preSelecao: { trabalhador_id: t.id } })}>
                                            {t.nome}
                                            {t.ativo === false && <span style={{ color: '#b45309', fontSize: '0.65rem', marginLeft: 5 }} title={`Saiu em ${fmtData(t.inativo_em)}`}>· saiu</span>}
                                        </td>
                                        {MESES_CURTO.map((m, mi) => Array.from({ length: diasNoMes(ano, mi) }, (_, di) => {
                                            const dia = di + 1;
                                            const chave = `${t.id}|${ano}-${String(mi + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
                                            const a = porDia.get(chave);
                                            const fds = ehFimSemana(ano, mi, dia);
                                            return (
                                                <td key={`${m}-${dia}`}
                                                    onClick={() => clicarDia(t, `${ano}-${String(mi + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`)}
                                                    title={a ? `${TIPOS[a.tipo]?.label}: ${fmtData(a.data_inicio)} a ${fmtData(a.data_fim)} — clique para mudar` : `${dia} ${MESES[mi]} — clique para marcar férias`}
                                                    style={{
                                                        background: a ? (TIPOS[a.tipo]?.cor || TIPOS.outro.cor) : (fds ? '#f1f5f9' : '#fff'),
                                                        borderLeft: di === 0 ? '2px solid #cbd5e1' : '1px solid #f1f5f9',
                                                        borderBottom: '1px solid #f1f5f9',
                                                        width: 10, minWidth: 10, height: 22, padding: 0, cursor: 'pointer',
                                                        opacity: a && a.estado === 'planeada' ? 0.55 : 1,
                                                    }} />
                                            );
                                        }))}
                                        <td style={{ textAlign: 'center', fontWeight: 700, color: '#166534', padding: '0 8px', borderLeft: '2px solid #cbd5e1' }}>{totalFerias(t.id) || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

            {/* Lista de períodos do ano */}
            {!loading && dados.ausencias.length > 0 && (
                <div style={{ marginTop: 22 }}>
                    <h3 style={{ fontSize: '1rem', margin: '0 0 8px' }}>Períodos registados em {ano} ({dados.ausencias.length})</h3>
                    <div data-liquid-surface="true" className="table-responsive" style={{ background: '#fff', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto' }}>
                        <table className="standard-table">
                            <thead>
                                <tr>
                                    <th>Trabalhador</th><th>Tipo</th><th>Início</th><th>Fim</th>
                                    <th style={{ textAlign: 'center' }}>Dias úteis</th><th>Estado</th><th>Observações</th>
                                    <th style={{ textAlign: 'right' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {dados.ausencias.map(a => {
                                    const tp = TIPOS[a.tipo] || TIPOS.outro;
                                    return (
                                        <tr key={a.id}>
                                            <td style={{ fontWeight: 600 }}>{a.trabalhador_nome}</td>
                                            <td><span style={{ ...badge, background: tp.bg, color: tp.fg }}><LiquidText>{tp.label}</LiquidText></span></td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{fmtData(a.data_inicio)}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{fmtData(a.data_fim)}</td>
                                            <td style={{ textAlign: 'center' }}>{diasUteis(a.data_inicio, a.data_fim, ano)}</td>
                                            <td style={{ textTransform: 'capitalize', color: a.estado === 'planeada' ? '#854d0e' : '#166534' }}>{a.estado}</td>
                                            <td style={{ maxWidth: 260, fontSize: '0.83rem', color: '#64748b' }}>{a.observacoes || '—'}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                <button onClick={() => setEditar({ registo: a })} style={{ ...btnSec, padding: '4px 10px', fontSize: '0.78rem' }}>Editar</button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {editar && (
                <PeriodoModal
                    registo={editar.registo}
                    preSelecao={editar.preSelecao}
                    trabalhadores={dados.trabalhadores}
                    onClose={() => setEditar(null)}
                    onSaved={carregar}
                />
            )}
        </div>
    );
};

/* ============================================================
   REGISTO DE HORAS — separador de gestão
   As horas chegam do telemóvel (/registo-horas, um registo por dia);
   aqui vê-se o mês inteiro e corrigem-se ou lançam-se registos à mão.
   ============================================================ */
function HorasModal({ registo, preSelecao, trabalhadores, obras, onClose, onSaved }) {
    const liquidFeedback = useLiquidFeedback();
    const novo = !registo;
    const [form, setForm] = useState(() => novo ? {
        trabalhador_id: preSelecao?.trabalhador_id || '', data: preSelecao?.data || '',
        horas: '8', horas_extra: '', obra_id: '', observacoes: '',
    } : {
        trabalhador_id: registo.trabalhador_id, data: soData(registo.data),
        horas: String(Number(registo.horas)),
        horas_extra: Number(registo.horas_extra) > 0 ? String(Number(registo.horas_extra)) : '',
        obra_id: registo.obra_id || '', observacoes: registo.observacoes || '',
    });
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState('');
    const upd = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

    const guardar = async () => {
        setSaving(true); setErr('');
        try {
            await api.post('/rh/horas', { ...form, obra_id: form.obra_id || null });
            onSaved(); onClose();
        } catch (e) { setErr(e.response?.data?.error || 'Erro ao guardar'); }
        finally { setSaving(false); }
    };
    const eliminar = async () => {
        if (!await liquidFeedback.confirm('Eliminar este registo de horas?')) return;
        try { await api.delete(`/rh/horas/${registo.id}`); onSaved(); onClose(); }
        catch { liquidFeedback.notify('Erro ao eliminar'); }
    };

    return (
        <LiquidDialog onClose={onClose} style={overlay} onClick={onClose}>
            <div style={{ ...modal, maxWidth: 520 }} onClick={e => e.stopPropagation()}>
                <div style={modalHead}>
                    <h3 style={{ margin: 0 }}>{novo ? 'Registar horas' : 'Editar horas'}</h3>
                    <button onClick={onClose} style={closeBtn}><LiquidText>✕</LiquidText></button>
                </div>
                <div data-liquid-grid="true" style={grid2}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Trabalhador *</label>
                        <select value={form.trabalhador_id} onChange={e => upd('trabalhador_id', e.target.value)} style={{ ...inp, width: '100%' }} disabled={!novo}>
                            <option value="">Selecione…</option>
                            {trabalhadores.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                        </select>
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Data *</label>
                        <input type="date" value={form.data} onChange={e => upd('data', e.target.value)} style={{ ...inp, width: '100%' }} disabled={!novo} />
                    </div>
                </div>
                <div data-liquid-grid="true" style={grid2}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Horas</label>
                        <input type="number" step="0.5" min="0" max="24" value={form.horas} onChange={e => upd('horas', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Horas extra</label>
                        <input type="number" step="0.5" min="0" max="24" value={form.horas_extra} onChange={e => upd('horas_extra', e.target.value)} style={{ ...inp, width: '100%' }} placeholder="0" />
                    </div>
                </div>
                <div style={{ marginBottom: 10 }}>
                    <label data-liquid-label="true" style={lbl}>Obra</label>
                    <select value={form.obra_id} onChange={e => upd('obra_id', e.target.value)} style={{ ...inp, width: '100%' }}>
                        <option value="">— Sem obra / escritório —</option>
                        {obras.map(o => <option key={o.id} value={o.id}>{[o.posicao, o.descricao || o.cliente].filter(Boolean).join(' - ')}</option>)}
                    </select>
                </div>
                <div style={{ marginBottom: 6 }}>
                    <label data-liquid-label="true" style={lbl}>Observações</label>
                    <textarea rows={2} value={form.observacoes} onChange={e => upd('observacoes', e.target.value)} style={{ ...inp, width: '100%', resize: 'vertical' }} />
                </div>
                {!novo && <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>Registado via {registo.origem === 'mobile' ? 'telemóvel' : 'RH'}</div>}
                {err && <div style={{ color: '#e53e3e', margin: '10px 0', fontSize: '0.85rem' }}>{err}</div>}
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginTop: 14 }}>
                    {novo ? <span /> : <button onClick={eliminar} style={{ ...btnSec, color: '#dc2626', borderColor: '#fca5a5' }}><DeleteIcon /> Eliminar</button>}
                    <div data-liquid-actions="true" style={{ display: 'flex', gap: 8 }}>
                        <button onClick={onClose} style={btnSec}>Cancelar</button>
                        <button data-liquid-primary="true" onClick={guardar} disabled={saving} style={{ ...btnPri, opacity: saving ? 0.6 : 1 }}>{saving ? 'A guardar…' : 'Guardar'}</button>
                    </div>
                </div>
            </div>
        </LiquidDialog>
    );
}

function RegistoHorasRH({ filtrosDestino, acoesDestino }) {
    const agora = new Date();
    const [ano, setAno] = useState(agora.getFullYear());
    const [mes, setMes] = useState(agora.getMonth()); // 0..11
    const [dados, setDados] = useState({ trabalhadores: [], registos: [] });
    const [obras, setObras] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pesquisa, setPesquisa] = useState('');
    const [editar, setEditar] = useState(null); // { registo } | { preSelecao }

    const carregar = useCallback(async () => {
        setLoading(true);
        try {
            const r = await api.get('/rh/horas', { params: { ano, mes: mes + 1, _t: Date.now() } });
            setDados({ trabalhadores: r.data.trabalhadores || [], registos: r.data.registos || [] });
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    }, [ano, mes]);
    useEffect(() => { carregar(); }, [carregar]);
    useEffect(() => {
        api.get('/obras')
            .then(r => { const l = r.data?.obras || r.data || []; setObras(l.filter(o => o.estado !== 'Concluida' && o.estado !== 'Cancelada')); })
            .catch(() => {});
    }, []);

    const anos = [];
    for (let a = agora.getFullYear() + 1; a >= agora.getFullYear() - 3; a--) anos.push(a);
    const nDias = diasNoMes(ano, mes);

    const porDia = useMemo(() => {
        const m = new Map();
        dados.registos.forEach(r => m.set(`${r.trabalhador_id}|${soData(r.data)}`, r));
        return m;
    }, [dados.registos]);

    const trabalhadores = pesquisa.trim()
        ? dados.trabalhadores.filter(t => (t.nome || '').toLowerCase().includes(pesquisa.trim().toLowerCase()))
        : dados.trabalhadores;

    const soma = (regs) => regs.reduce((a, r) => ({ h: a.h + Number(r.horas || 0), e: a.e + Number(r.horas_extra || 0), d: a.d + 1 }), { h: 0, e: 0, d: 0 });
    const totalGeral = soma(dados.registos);

    return (
        <div>
            {filtrosDestino && createPortal(<div className="rh-filtros-comuns"><div>
                        <label data-liquid-label="true" style={lbl}>Ano</label>
                        <select value={ano} onChange={e => setAno(parseInt(e.target.value, 10))} style={inp}>
                            {anos.map(a => <option key={a} value={a}>{a}</option>)}
                        </select>
                    </div>
<div>
                        <label data-liquid-label="true" style={lbl}>Mês</label>
                        <select value={mes} onChange={e => setMes(parseInt(e.target.value, 10))} style={inp}>
                            {MESES.map((m, i) => <option key={m} value={i}>{m}</option>)}
                        </select>
                    </div></div>, filtrosDestino)}
{acoesDestino && createPortal(<div className="rh-acoes-comuns"><button data-liquid-primary="true" onClick={() => setEditar({ preSelecao: {} })} style={btnPri}>+ Registar horas</button>
<div>
                        
                        <input value={pesquisa} onChange={e => setPesquisa(e.target.value)} aria-label="Pesquisa por nome de colaborador" placeholder="Pesquisa por nome de colaborador" style={{ ...inp, width: 200 }} />
                    </div></div>, acoesDestino)}

            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 14, alignItems: 'center', fontSize: '0.82rem', color: '#475569' }}>
                <span><b style={{ color: '#1e5aa8' }}>{totalGeral.h}h</b> normais · <b style={{ color: '#9a3412' }}>{totalGeral.e}h</b> extra em {MESES[mes]} {ano}</span>
                <span style={{ color: '#94a3b8' }}>· Clique numa célula para registar ou editar · célula laranja = tem horas extra</span>
            </div>

            {loading ? <p style={{ color: '#718096' }}>A carregar…</p>
                : trabalhadores.length === 0 ? (
                    <div style={{ padding: '48px 0', textAlign: 'center', color: '#94a3b8' }}>Sem trabalhadores ativos para mostrar.</div>
                ) : (
                    <div data-liquid-surface="true" className="table-responsive" style={{ background: '#fff', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto' }}>
                        <table data-liquid-calendar="true" style={{ borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                            <thead>
                                <tr>
                                    <th style={{ ...thSticky, minWidth: 200 }}>Trabalhador</th>
                                    {Array.from({ length: nDias }, (_, i) => i + 1).map(d => (
                                        <th key={d} style={{ width: 30, minWidth: 30, padding: 2, textAlign: 'center', color: ehFimSemana(ano, mes, d) ? '#94a3b8' : '#475569', fontSize: '0.7rem', borderBottom: '1px solid #e2e8f0' }}>{d}</th>
                                    ))}
                                    {['Dias', 'Horas', 'Extra'].map(h => (
                                        <th key={h} style={{ padding: '4px 8px', fontSize: '0.72rem', color: '#475569', borderBottom: '1px solid #e2e8f0', whiteSpace: 'nowrap' }}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {trabalhadores.map(t => {
                                    const tot = soma(dados.registos.filter(r => r.trabalhador_id === t.id));
                                    return (
                                        <tr key={t.id}>
                                            <td style={{ ...tdSticky, minWidth: 200 }}>{t.nome}</td>
                                            {Array.from({ length: nDias }, (_, i) => i + 1).map(d => {
                                                const data = `${ano}-${String(mes + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
                                                const r = porDia.get(`${t.id}|${data}`);
                                                const fds = ehFimSemana(ano, mes, d);
                                                const extra = r ? Number(r.horas_extra || 0) : 0;
                                                return (
                                                    <td key={d}
                                                        onClick={() => setEditar(r ? { registo: r } : { preSelecao: { trabalhador_id: t.id, data } })}
                                                        title={r
                                                            ? `${Number(r.horas)}h${extra > 0 ? ` + ${extra}h extra` : ''}${r.obra_posicao ? ` · Obra ${r.obra_posicao}` : ''}${r.observacoes ? ` — ${r.observacoes}` : ''} (via ${r.origem === 'mobile' ? 'telemóvel' : 'RH'})`
                                                            : 'Clique para registar'}
                                                        style={{
                                                            background: r ? (extra > 0 ? '#fff7ed' : '#eff6ff') : (fds ? '#f1f5f9' : '#fff'),
                                                            border: '1px solid #e2e8f0', width: 30, minWidth: 30, height: 26, padding: 0,
                                                            cursor: 'pointer', textAlign: 'center', fontSize: '0.72rem', color: '#1e3a5f', fontWeight: r ? 600 : 400,
                                                        }}>
                                                        {r ? Number(r.horas) + extra : ''}
                                                    </td>
                                                );
                                            })}
                                            <td style={{ textAlign: 'center', padding: '0 8px' }}>{tot.d || '—'}</td>
                                            <td style={{ textAlign: 'center', fontWeight: 700, color: '#1e5aa8', padding: '0 8px' }}>{tot.h || '—'}</td>
                                            <td style={{ textAlign: 'center', fontWeight: 700, color: '#9a3412', padding: '0 8px' }}>{tot.e || '—'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

            {editar && (
                <HorasModal
                    registo={editar.registo}
                    preSelecao={editar.preSelecao}
                    trabalhadores={dados.trabalhadores}
                    obras={obras}
                    onClose={() => setEditar(null)}
                    onSaved={carregar}
                />
            )}
        </div>
    );
}

/* ============================================================
   VENCIMENTOS — salário base, valor/hora, valor/hora extra, valor/km
   Só administradores (a API responde 403 aos restantes).
   ============================================================ */
// Francisco Ramos (tem_teto): os valores ficam como são escritos. Só o botão
// «Recalcular», ao lado do nome, aplica o teto dos 920,00 € no servidor.

const CAMPOS_VENC = [
    ['simulacao_fiscomapa', 'Simulação (Fiscomapa)'],
    ['valor_jose_tripa', 'Valores José Tripa'],
    ['valor_kms', 'Valor p/ Kms'],
    ['kms', 'Kms'],
];

// Ponto nos milhares (incluindo valores de quatro algarismos) e vírgula nos cêntimos.
const formatoMoedaVenc = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', useGrouping: true });

function ValorMonetarioVenc({ value, onChange, onBlur, label, disabled = false, restrito = false }) {
    const [focado, setFocado] = useState(false);
    // Zero aparece como vazio (fica só o marcador cinzento), como nas linhas sem valor.
    const vazio = value === '' || value == null || (!focado && Number(value) === 0);
    const texto = vazio ? '' : focado
        ? String(value).replace('.', ',')
        : formatoMoedaVenc.format(Number(value));

    const alterar = (textoNovo) => {
        let numero = textoNovo.replace(/[\s€]/g, '');
        if (numero.includes(',')) numero = numero.replace(/\./g, '').replace(',', '.');
        if (/^\d*(?:\.\d{0,2})?$/.test(numero) && (numero === '' || (Number.isFinite(Number(numero)) && Number(numero) <= 100000))) {
            onChange(numero);
        }
    };

    return (
        <input type="text" inputMode="decimal" data-valor-restrito={restrito ? "true" : undefined} disabled={disabled} title={restrito ? 'Só Tiago Monteiro pode editar este valor' : undefined} aria-label={label + ' (euros)'}
            value={texto} onChange={e => alterar(e.target.value)}
            onFocus={() => setFocado(true)} onBlur={() => { setFocado(false); onBlur?.(); }}
            onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); }}
            placeholder="0,00 €" style={{ ...inp, width: 120, textAlign: 'center', ...(disabled ? { cursor: 'not-allowed', opacity: 1 } : {}) }} />
    );
}

function Vencimentos({ controlosDestino, gravarDestino }) {
    const { user } = useAuth();
    // A conta Tiago Monteiro tem acesso a toda a coluna, mesmo sem a indicação por linha.
    const podeEditarJoseTripa = l => {
        if (Number(user?.id) === 9) return true;
        if ([35, 11, 37, 19, 36].includes(Number(l.trabalhador_id))) return false;
        return l.pode_editar_valor_jose_tripa === true;
    };
    const [periodo, setPeriodo] = useState(() => {
        const hoje = new Date();
        return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`;
    });
    const pedidoCarga = useRef(0);
    const [linhas, setLinhas] = useState([]);
    const [ordemVenc, setOrdemVenc] = useState(() => { try { return localStorage.getItem('rh-venc-ordem') || 'personalizada'; } catch { return 'personalizada'; } });
    const mudarOrdemVenc = v => { setOrdemVenc(v); try { localStorage.setItem('rh-venc-ordem', v); } catch {} };
    const [loading, setLoading] = useState(true);
    const [semAcesso, setSemAcesso] = useState(false);
    const [edit, setEdit] = useState({});     // trabalhador_id -> { campo: valor }
    const [saving, setSaving] = useState(0);
    const gravacaoEmCurso = useRef(false);
    const [msg, setMsg] = useState('');
    const [pesquisa, setPesquisa] = useState('');
    const inputPdf = useRef(null);
    /* Recibos de vencimento: um ou mais ficheiros por trabalhador e por mês.
       Ficam numa pasta fechada; abrem-se por rota autenticada, como blob. */
    const [pedidoEmail, setPedidoEmail] = useState(null);
    const [recibos, setRecibos] = useState({});          // trabalhador_id -> [anexos]
    const [reciboOcupado, setReciboOcupado] = useState(null);
    const inputRecibo = useRef(null);
    const [reciboPara, setReciboPara] = useState(null);  // trabalhador a receber o ficheiro
    const carregarRecibos = useCallback(async (p) => {
        try {
            const r = await api.get('/rh/vencimentos/anexos', { params: { periodo: p, _t: Date.now() } });
            const porTrab = {};
            (r.data || []).forEach(a => {
                (porTrab[a.trabalhador_id] = porTrab[a.trabalhador_id] || []).push(a);
            });
            setRecibos(porTrab);
        } catch { setRecibos({}); }
    }, []);
    const inputProcessados = useRef(null);
    const [loteProcessados, setLoteProcessados] = useState(null);
    const [ocupadoProcessados, setOcupadoProcessados] = useState(false);
    const processadosEmCurso = useRef(false);
    const [erroProcessados, setErroProcessados] = useState('');
    const importarProcessados = async (ficheiro, confirmar = false) => {
        if (!ficheiro || processadosEmCurso.current) return;
        const mes = confirmar ? loteProcessados.periodo : periodo;
        processadosEmCurso.current = true; setOcupadoProcessados(true); setErroProcessados('');
        if (!confirmar) setLoteProcessados(null);
        try {
            const fd = new FormData(); fd.append('pdf', ficheiro); fd.append('periodo', mes);
            fd.append('confirmar', String(confirmar));
            const { data } = await api.post('/rh/vencimentos/recibos-processados', fd, { timeout: 120000 });
            setLoteProcessados({ ...data, ficheiro, concluido: confirmar });
            if (confirmar) await carregarRecibos(mes);
        } catch (e) { setErroProcessados(e.response?.data?.error || 'Não foi possível concluir. Podes tentar novamente; recibos já importados serão ignorados.'); }
        finally { processadosEmCurso.current = false; setOcupadoProcessados(false); if (inputProcessados.current) inputProcessados.current.value = ''; }
    };
    const enviarRecibo = async (ficheiro) => {
        if (!ficheiro || !reciboPara) return;
        setReciboOcupado(reciboPara);
        try {
            const fd = new FormData();
            fd.append('periodo', periodo);
            fd.append('files', ficheiro);
            await api.post(`/rh/vencimentos/${reciboPara}/anexos`, fd);
            await carregarRecibos(periodo);
        } catch (e) {
            setMsg(e.response?.data?.error || 'Não foi possível anexar o recibo.');
        } finally {
            setReciboOcupado(null); setReciboPara(null);
            if (inputRecibo.current) inputRecibo.current.value = '';
        }
    };
    const abrirRecibo = async (a) => {
        try {
            const r = await api.get(`/rh/vencimentos/anexos/${a.id}`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(r.data);
            window.open(url, '_blank', 'noopener');
            setTimeout(() => window.URL.revokeObjectURL(url), 60000);
        } catch { setMsg('Não foi possível abrir o recibo.'); }
    };
    const apagarRecibo = async (a) => {
        if (!window.confirm(`Apagar o recibo «${a.nome_original || 'ficheiro'}»?`)) return;
        try {
            await api.delete(`/rh/vencimentos/anexos/${a.id}`);
            await carregarRecibos(periodo);
        } catch { setMsg('Não foi possível apagar o recibo.'); }
    };
    const { pendentes: avisosVenc, recarregar: recarregarAvisoVenc } = useAvisoVencimentos();
    const avisoDoMes = (avisosVenc || []).find(p => p.periodo === periodo);
    const [desligandoAviso, setDesligandoAviso] = useState(false);
    const chaveDestaques = 'rh_vencimentos_destaques_desativados_' + user?.id;
    const [destaquesDesativados, setDestaquesDesativados] = useState(() => {
        try { return JSON.parse(localStorage.getItem('rh_vencimentos_destaques_desativados_' + user?.id)) || {}; }
        catch { return {}; }
    });
    const desligarAviso = async () => {
        setDesligandoAviso(true);
        try {
            await api.post('/rh/vencimentos/aviso/visto', { periodo });
            setDestaquesDesativados(anteriores => {
                const novos = { ...anteriores, [periodo]: avisoDoMes?.n || 0 };
                try { localStorage.setItem(chaveDestaques, JSON.stringify(novos)); } catch {}
                return novos;
            });
            await recarregarAvisoVenc();
        }
        catch (e) { setMsg(e.response?.data?.error || 'Não foi possível desligar o aviso.'); }
        finally { setDesligandoAviso(false); }
    };
    const [lendoPdf, setLendoPdf] = useState(false);
    const [fiscomapa, setFiscomapa] = useState(null);   // resumo do último PDF lido

    const mesExtenso = p => { const [a, m] = p.split('-'); return new Date(Number(a), Number(m) - 1, 1).toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' }); };

    // PDF dos recibos (simulação Fiscomapa): preenche a Simulação Fiscomapa com o
    // «Total a Receber» de cada trabalhador. Nada fica gravado até se premir Gravar.
    const carregarFiscomapa = async (ficheiro) => {
        if (!ficheiro) return;
        setMsg(''); setFiscomapa(null); setLendoPdf(true);
        try {
            const fd = new FormData();
            fd.append('pdf', ficheiro);
            const { data } = await api.post('/rh/vencimentos/fiscomapa', fd);
            if (data.periodo && data.periodo !== periodo) {
                setMsg(`O PDF é de ${mesExtenso(data.periodo)}, mas o quadro está em ${mesExtenso(periodo)}. Muda o mês e volta a carregar o PDF.`);
                return;
            }
            const atuais = new Map(linhas.map(l => [Number(l.trabalhador_id), l]));
            const preenchidos = data.linhas.filter(x => atuais.has(Number(x.trabalhador_id)));
            setEdit(prev => {
                const n = { ...prev };
                preenchidos.forEach(x => {
                    const l = atuais.get(Number(x.trabalhador_id));
                    const atual = n[x.trabalhador_id]?.simulacao_fiscomapa ?? l.simulacao_fiscomapa;
                    if (atual != null && atual !== '' && Number(atual) === Number(x.total)) return;
                    n[x.trabalhador_id] = { ...(n[x.trabalhador_id] || {}), simulacao_fiscomapa: Number(x.total).toFixed(2) };
                });
                return n;
            });
            setFiscomapa({ ...data, preenchidos: preenchidos.length });
        } catch (e) {
            setMsg(e.response?.data?.error || 'Não foi possível ler o PDF.');
        } finally {
            setLendoPdf(false);
            if (inputPdf.current) inputPdf.current.value = '';
        }
    };

    const carregar = useCallback(async () => {
        const pedido = ++pedidoCarga.current;
        setLoading(true); setLinhas([]);
        try {
            const r = await api.get('/rh/vencimentos', { params: { periodo, _t: Date.now() } });
            if (pedido !== pedidoCarga.current) return;
            setLinhas(r.data || []); setSemAcesso(false);
            setEdit({});
        } catch (e) {
            if (pedido !== pedidoCarga.current) return;
            if (e.response?.status === 403) setSemAcesso(true);
            else setMsg('Não foi possível carregar os valores deste mês. Volta a selecionar o mês para tentar novamente.');
        } finally { if (pedido === pedidoCarga.current) setLoading(false); }
    }, [periodo]);
    useEffect(() => { carregar(); }, [carregar]);
    useEffect(() => { carregarRecibos(periodo); }, [periodo, carregarRecibos]);

    const val = (l, c) => {
        const campo = key => edit[l.trabalhador_id]?.[key] !== undefined ? edit[l.trabalhador_id][key] : (l[key] ?? '');
        if (c === 'valor_kms') {
            const simulacao = campo('simulacao_fiscomapa');
            const valor = campo('valor_jose_tripa');
            // Recálculo aplicado e valores intactos: vale o Valor p/ Kms do servidor.
            if (tetoEmVigor(l)) return l.valor_kms ?? '';
            if (simulacao === '' || valor === '') return '';
            const centimos = Math.max(0, Math.round(Number(valor) * 100) - Math.round(Number(simulacao) * 100));
            return Math.ceil(centimos / 40) * 40 / 100;
        }
        return campo(c);
    };
    const set = (l, c, v) => setEdit(prev => ({ ...prev, [l.trabalhador_id]: { ...(prev[l.trabalhador_id] || {}), [c]: v } }));
    const alterado = (l) => !!edit[l.trabalhador_id];
    // Total Pago: o valor José Tripa (é o total a receber). No Francisco e no José
    // Manuel Tripa, depois do Recalcular, é Fiscomapa + José Tripa + Outros Valores
    // (antes do Recalcular o José Tripa ainda é o total, e soma-se sozinho).
    const totalPago = (l) => {
        const jt = val(l, 'valor_jose_tripa');
        if (jt === '') return '';
        if (l.tem_teto && tetoEmVigor(l)) {
            return Math.round((Number(val(l, 'simulacao_fiscomapa') || 0) + Number(jt) + Number(l.valor_roupa || 0)) * 100) / 100;
        }
        return Number(jt);
    };
    // O recálculo do teto continua em vigor enquanto a Simulação e o José Tripa não
    // forem alterados (ao gravar alterados, o servidor desfaz o recálculo).
    const tetoEmVigor = (l) => !!l.teto_aplicado
        && edit[l.trabalhador_id]?.valor_jose_tripa === undefined
        && edit[l.trabalhador_id]?.simulacao_fiscomapa === undefined;
    const [recalculando, setRecalculando] = useState(null);
    const recalcularTeto = async (l) => {
        setMsg(''); setRecalculando(l.trabalhador_id);
        try {
            const { data } = await api.post(`/rh/vencimentos/${l.trabalhador_id}/recalcular-teto`, { periodo });
            setLinhas(prev => prev.map(x => Number(x.trabalhador_id) === Number(l.trabalhador_id) ? { ...x, ...data } : x));
        } catch (e) {
            setMsg(e.response?.data?.error || 'Não foi possível recalcular.');
        } finally { setRecalculando(null); }
    };
    // Valores José Tripa abaixo da Simulação Fiscomapa: a linha fica a vermelho.
    // Não se aplica ao Francisco (tem_teto): nele o José Tripa é o total a receber.
    const jtInferior = (l) => {
        // O servidor deixa de devolver o aviso depois de este ser desativado.
        // Não depender só da preferência local: pode ter sido visto noutro navegador.
        if (!avisoDoMes) return false;
        if (Object.prototype.hasOwnProperty.call(destaquesDesativados, periodo)
            && (!avisoDoMes || avisoDoMes.n <= destaquesDesativados[periodo])) return false;
        if (l.tem_teto) return false;
        const sim = val(l, 'simulacao_fiscomapa'), jt = val(l, 'valor_jose_tripa');
        // José Tripa vazio ou a 0 = ainda não preenchido: não pinta a linha.
        return sim !== '' && jt !== '' && Number(jt) > 0 && Number(jt) < Number(sim);
    };
    const [estadoCopia, setEstadoCopia] = useState('');
    const copiarVencimentos = async () => {
        const escaparHtml = texto => String(texto).replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
        }[c]));
        const formatoValor = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const formatoKms = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
        const registos = linhas.map(l => {
            const valorKms = val(l, 'valor_kms');
            const valor = valorKms === '' ? '' : formatoValor.format(Number(valorKms)) + ' EUR';
            const kms = valorKms === '' ? '' : formatoKms.format(Math.round(Number(valorKms) * 100) / 40) + ' kms';
            return { nome: l.nome, detalhe: valor + ' > ' + kms + ';' };
        });
        const texto = registos.map(r => r.nome + ': ' + r.detalhe).join('\n');
        const html = '<div style="font-family:Verdana,sans-serif;font-size:13pt;color:#000;">'
            + registos.map(r => '<div style="font-family:Verdana,sans-serif;font-size:13pt;line-height:1.4;margin:0;">'
                + '<strong>' + escaparHtml(r.nome) + ':</strong> ' + escaparHtml(r.detalhe) + '</div>').join('')
            + '</div>';
        setEstadoCopia('');
        try {
            let copiado = false;
            if (navigator.clipboard?.write && typeof ClipboardItem !== 'undefined') {
                try {
                    await navigator.clipboard.write([new ClipboardItem({
                        'text/html': new Blob([html], { type: 'text/html' }),
                        'text/plain': new Blob([texto], { type: 'text/plain' }),
                    })]);
                    copiado = true;
                } catch {}
            }
            // A aplicação também é utilizada por HTTP na rede local.
            if (!copiado) {
                const foco = document.activeElement;
                const auxiliar = document.createElement('textarea');
                auxiliar.value = texto;
                auxiliar.readOnly = true;
                auxiliar.style.cssText = 'position:fixed;left:-9999px;top:0;';
                const copiarFormatado = evento => {
                    if (!evento.clipboardData) return;
                    evento.clipboardData.setData('text/html', html);
                    evento.clipboardData.setData('text/plain', texto);
                    evento.preventDefault();
                };
                document.body.appendChild(auxiliar);
                document.addEventListener('copy', copiarFormatado);
                try {
                    auxiliar.select();
                    copiado = document.execCommand('copy');
                } finally {
                    document.removeEventListener('copy', copiarFormatado);
                    auxiliar.remove();
                    foco?.focus({ preventScroll: true });
                }
                if (!copiado) throw new Error('Cópia indisponível');
            }
            setEstadoCopia('');
        } catch {
            setEstadoCopia('Não foi possível copiar os dados. Tenta novamente.');
        }
    };


    const guardar = async () => {
        if (gravacaoEmCurso.current) return;
        const pendentes = linhas.filter(l => edit[l.trabalhador_id]).map(l => {
            const body = { periodo, observacoes: val(l, 'observacoes') };
            CAMPOS_VENC.filter(([c]) => c !== 'kms' && c !== 'valor_kms'
                && (c !== 'valor_jose_tripa' || podeEditarJoseTripa(l)))
                .forEach(([c]) => { body[c] = val(l, c); });
            return { linha: l, body, snapshot: edit[l.trabalhador_id] };
        });
        if (!pendentes.length) return;
        gravacaoEmCurso.current = true;
        setSaving(1); setMsg('');
        const falhas = [];
        try {
            for (const item of pendentes) {
                try {
                    await api.put(`/rh/vencimentos/${item.linha.trabalhador_id}`, item.body);
                } catch (e) {
                    falhas.push(item.linha.nome);
                }
            }
            // Confirmar pela consulta mensal antes de limpar os valores introduzidos.
            const r = await api.get('/rh/vencimentos', { params: { periodo, _t: Date.now() } });
            if (!Array.isArray(r.data)) throw new Error('Resposta inválida');
            const confirmados = [];
            for (const item of pendentes) {
                const guardado = r.data.find(l => Number(l.trabalhador_id) === Number(item.linha.trabalhador_id));
                const coincide = guardado && Object.entries(item.body).every(([campo, valor]) => {
                    if (campo === 'periodo') return true;
                    if (campo === 'observacoes') return (guardado[campo] || '') === (valor || '');
                    if (valor === '' || valor == null) return guardado[campo] == null;
                    return guardado[campo] != null && Number(guardado[campo]) === Number(valor);
                });
                if (coincide && !falhas.includes(item.linha.nome)) confirmados.push(item);
                else if (!falhas.includes(item.linha.nome)) falhas.push(item.linha.nome);
            }
            setLinhas(r.data);
            setEdit(prev => {
                const n = { ...prev };
                confirmados.forEach(item => {
                    if (n[item.linha.trabalhador_id] === item.snapshot) delete n[item.linha.trabalhador_id];
                });
                return n;
            });
            recarregarAvisoVenc();
            setMsg(falhas.length
                ? `Não foi possível confirmar a gravação de: ${falhas.join(', ')}. Os valores continuam no quadro; prime Gravar para tentar novamente.`
                : `Guardado: quadro de ${periodo.split('-').reverse().join('/')}.`);
        } catch (e) {
            setMsg('Não foi possível confirmar a gravação. Os valores continuam no quadro; prime Gravar para tentar novamente.');
        } finally {
            gravacaoEmCurso.current = false;
            setSaving(0);
        }
    };

    const filtradas = pesquisa.trim()
        ? linhas.filter(l => (l.nome || '').toLowerCase().includes(pesquisa.trim().toLowerCase()))
        : linhas;
    // Ordem personalizada (pedido do Tiago, 25-10-2026): primeiro o escritório
    // pela ordem fixa abaixo, depois a obra com o José Manuel Tripa à cabeça e os
    // restantes por ordem alfabética. A alternativa é tudo por ordem alfabética.
    const porNome = (a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt', { sensitivity: 'base' });
    const lista = ordemVenc === 'alfabetica' ? [...filtradas].sort(porNome) : [...filtradas].sort((a, b) => {
        const pos = l => { const i = ORDEM_ESCRITORIO_VENC.indexOf(Number(l.trabalhador_id)); return i >= 0 ? i : (Number(l.trabalhador_id) === 10 ? 100 : 101); };
        return (pos(a) - pos(b)) || porNome(a, b);
    });

    if (semAcesso) {
        return <div style={{ padding: '48px 0', textAlign: 'center', color: '#94a3b8' }}>Os vencimentos só estão disponíveis a administradores.</div>;
    }

    return (
        <div>
            {pedidoEmail && <RecibosEmail pedido={pedidoEmail} fechar={() => setPedidoEmail(null)} />}
            {gravarDestino && createPortal(
                    <div className="rh-vencimentos-gravar">
                <button data-liquid-primary="true" onClick={guardar}
                    disabled={loading || saving > 0 || Object.keys(edit).length === 0} style={btnPri}>
                    {saving > 0 ? 'A gravar…' : 'Gravar Registo de Vencimento'}
                </button>
                    </div>
            , gravarDestino)}
            {controlosDestino && createPortal(
                <>
                    <div className="rh-vencimentos-filtros">
                    <div className="rh-vencimentos-periodo">
                        <label data-liquid-label="true" style={lbl} htmlFor="vencimentos-periodo">Mês / Ano</label>
                        <input id="vencimentos-periodo" type="month" min="1900-01" max="2199-12" value={periodo}
                            disabled={saving > 0 || ocupadoProcessados || Object.keys(edit).length > 0}
                            title={Object.keys(edit).length > 0 ? 'Prime Gravar antes de mudar de mês.' : 'Seleciona um mês para preencher ou consultar o histórico'}
                            onChange={e => {
                                if (!/^(19|20|21)\d{2}-(0[1-9]|1[0-2])$/.test(e.target.value)) return;
                                setMsg(''); setLinhas([]); setLoading(true); setPeriodo(e.target.value);
                            }} style={{ ...inp, width: 185 }} />
                    </div>
                <input id="rh-pesquisa-colaborador" aria-label="Pesquisa por nome de colaborador" value={pesquisa}
                    onChange={e => setPesquisa(e.target.value)} placeholder="Pesquisa por nome de colaborador"
                    style={{ ...inp, width: 280, maxWidth: '100%', textAlign: 'center' }} />
                <div className="rh-vencimentos-periodo">
                    <label data-liquid-label="true" style={lbl} htmlFor="vencimentos-ordem">Ordenação</label>
                    <select id="vencimentos-ordem" value={ordemVenc} onChange={e => mudarOrdemVenc(e.target.value)}
                        title="Escritório / Obra: escritório primeiro, depois a obra. Alfabética: todos por ordem do nome."
                        style={{ ...inp, width: 190, height: 36, boxSizing: 'border-box', textAlign: 'center', textAlignLast: 'center' }}>
                        <option value="personalizada">Escritório / Obra</option>
                        <option value="alfabetica">Alfabética</option>
                    </select>
                </div>
                    </div>
                    <div className="rh-vencimentos-acoes">



            <div className="rh-vencimentos-pesquisa">
                <button type="button" className="rh-copiar-vencimentos" data-liquid-primary="true"
                    style={btnPri} disabled={loading || linhas.length === 0}
                    onClick={copiarVencimentos}>Copiar Dados para E-Mail</button>
            </div>
                        <div className="rh-vencimentos-pesquisa">
                        <button type="button" className="rh-importar-recibos" data-liquid-primary="true" style={btnPri} disabled={loading || ocupadoProcessados}
                            onClick={() => inputProcessados.current?.click()}>
                            {ocupadoProcessados ? 'A processar recibos…' : 'Importar recibos processados'}
                        </button>
                        </div>
                    </div>
                </>, controlosDestino
            )}

            <input ref={inputProcessados} type="file" accept="application/pdf,.pdf" hidden
                onChange={e => importarProcessados(e.target.files?.[0])} />
            {erroProcessados && <p role="alert" style={{ color: '#b91c1c' }}>{erroProcessados}</p>}
            {loteProcessados && (
                <section aria-label="Importação de recibos processados" style={{ padding: 16, marginBottom: 16, border: '1px solid #bfd5e8', borderRadius: 8, background: '#f4f8fc' }}>
                    <strong>Recibos processados — {mesExtenso(loteProcessados.periodo)}</strong>
                    <p>{loteProcessados.concluido ? 'Importação concluída. Os recibos estão nos anexos de cada colaborador.' : 'Confere as associações antes de guardar. Os valores da simulação não serão alterados.'}</p>
                    <div style={{ maxHeight: 300, overflow: 'auto' }}>
                        <table className="standard-table" style={{ width: '100%' }}>
                            <thead><tr><th>Colaborador</th><th>Página(s)</th><th>Estado</th></tr></thead>
                            <tbody>{loteProcessados.linhas.map(l => <tr key={l.trabalhador_id}>
                                <td>{l.nome}</td><td>{l.paginas.join(', ')}</td>
                                <td>{l.estado === 'existente' ? 'Já importado — ignorado' : l.estado === 'importado' ? 'Anexado' : 'Pronto para anexar'}</td>
                            </tr>)}</tbody>
                        </table>
                    </div>
                    {loteProcessados.pendentes.length > 0 && <div role="status">
                        <p>As seguintes páginas não serão anexadas automaticamente. Podes usar a opção de anexo individual após as verificares.</p>
                        {loteProcessados.pendentes.map(l => <p key={l.pagina}>Página {l.pagina}: {l.motivo}</p>)}
                    </div>}
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 12 }}>
                        <button type="button" style={btnSec} disabled={ocupadoProcessados} onClick={() => setLoteProcessados(null)}>{loteProcessados.concluido ? 'Fechar' : 'Cancelar'}</button>
                        {!loteProcessados.concluido && <button type="button" style={btnPri}
                            disabled={ocupadoProcessados || loteProcessados.periodo !== periodo || !loteProcessados.linhas.some(l => l.estado === 'pronto')}
                            onClick={() => importarProcessados(loteProcessados.ficheiro, true)}>
                            {ocupadoProcessados ? 'A anexar…' : 'Confirmar e anexar recibos'}
                        </button>}
                    </div>
                    {loteProcessados.periodo !== periodo && <p>Seleciona o mês deste lote para o confirmar.</p>}
                </section>
            )}
            {Object.keys(edit).length > 0 && <p style={{ color: '#64748b', fontSize: '0.85rem', margin: '0 0 12px' }}>Existem alterações por gravar neste mês.</p>}
            {msg && <div role="status" style={{ marginBottom: 12, fontSize: '0.85rem', color: msg.startsWith('Guardado') ? '#166534' : '#b91c1c' }}>{msg}</div>}

            <div role="status" aria-live="polite" className="rh-estado-copia">{estadoCopia}</div>
            {avisoDoMes && (
                <div role="status" style={{ marginBottom: 12, padding: '10px 14px', border: '1px solid #fcd34d', background: '#fffbeb', borderRadius: 8, fontSize: '0.85rem', color: '#78350f', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                    <span>🔔 Foram introduzidos <strong>{avisoDoMes.n} valores José Tripa</strong> em {mesExtenso(periodo)}: já há valores para o processamento dos salários.</span>
                    <button type="button" onClick={desligarAviso} disabled={desligandoAviso}
                        style={{ padding: '5px 12px', border: '1px solid #d97706', borderRadius: 6, background: '#fff', color: '#92400e', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                        {desligandoAviso ? 'A desligar…' : 'Desativar notificação'}
                    </button>
                </div>
            )}
            {fiscomapa && (
                <div role="status" style={{ marginBottom: 12, padding: '10px 14px', border: '1px solid #bfdbfe', background: '#eff6ff', borderRadius: 8, fontSize: '0.85rem', color: '#1e3a5f' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                        <strong>PDF Fiscomapa{fiscomapa.periodo ? ` de ${mesExtenso(fiscomapa.periodo)}` : ''}: Simulação Fiscomapa preenchida para {fiscomapa.preenchidos} trabalhador{fiscomapa.preenchidos === 1 ? '' : 'es'}. Confere e prime Gravar.</strong>
                        <button type="button" onClick={() => setFiscomapa(null)} aria-label="Fechar resumo" style={{ border: 0, background: 'none', cursor: 'pointer', color: '#64748b' }}>✕</button>
                    </div>
                    {fiscomapa.linhas.some(x => x.criterio === 'nome') && (
                        <div style={{ marginTop: 6 }}>Ligados pelo nome (o NIF não está na ficha{fiscomapa.linhas.some(x => x.nif_diferente) ? ' ou é diferente' : ''}): {fiscomapa.linhas.filter(x => x.criterio === 'nome').map(x => `${x.nome}${x.nif_diferente ? ` (NIF do recibo ${x.nif_pdf} diferente do da ficha)` : ''}`).join('; ')}.</div>
                    )}
                    {fiscomapa.sem_correspondencia.length > 0 && (
                        <div style={{ marginTop: 6, color: '#b91c1c' }}>Recibos não usados: {fiscomapa.sem_correspondencia.map(x => `${x.nome_pdf || 'página ' + x.pagina} (${x.motivo})`).join('; ')}.</div>
                    )}
                    {fiscomapa.sem_recibo.length > 0 && (
                        <div style={{ marginTop: 6, color: '#92400e' }}>Sem recibo no PDF: {fiscomapa.sem_recibo.join(', ')}.</div>
                    )}
                </div>
            )}
            {loading ? <p style={{ color: '#718096' }}>A carregar…</p> : (
                <div data-liquid-surface="true" className="table-responsive" style={{ background: '#fff', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto' }}>
                    <table className="standard-table rh-vencimentos-table">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                    <input ref={inputPdf} type="file" accept="application/pdf,.pdf" hidden
                                        onChange={e => carregarFiscomapa(e.target.files?.[0])} />
                                    <input ref={inputRecibo} type="file" accept="application/pdf,.pdf,image/*" hidden
                                        onChange={e => enviarRecibo(e.target.files?.[0])} />
                                    <button type="button" disabled={saving > 0 || lendoPdf || linhas.length === 0}
                                        title="Carregar o PDF Fiscomapa: preenche a Simulação Fiscomapa com o Total a Receber de cada recibo"
                                        onClick={() => inputPdf.current?.click()}
                                        style={{ float: 'left', marginRight: 10, padding: '3px 8px', fontSize: 11, fontWeight: 600, textTransform: 'none', letterSpacing: 0,
                                            border: '1px solid #cbd5e1', borderRadius: 6, background: '#fff', color: '#334155',
                                            cursor: saving > 0 || lendoPdf ? 'wait' : 'pointer', verticalAlign: 'middle' }}>
                                        {lendoPdf ? 'A ler…' : '📄 PDF'}
                                    </button>
                                    Trabalhadores
                                </th>
                                {CAMPOS_VENC.map(([c, label]) => (
                                    <React.Fragment key={c}>
                                    <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                        {c === 'simulacao_fiscomapa' ? (
                                            <><LiquidText>Simulação</LiquidText><br /><LiquidText>Fiscomapa</LiquidText></>
                                        ) : c === 'valor_jose_tripa' ? (
                                            <><LiquidText>Valores</LiquidText><br /><LiquidText>José Tripa</LiquidText></>
                                        ) : c === 'valor_kms' ? (
                                            <><LiquidText>Valor</LiquidText><br /><LiquidText>P/ Kms</LiquidText></>
                                        ) : c === 'kms' ? (
                                            <><LiquidText>KMS</LiquidText><br /><LiquidText>PERCORRIDOS</LiquidText></>
                                        ) : <LiquidText>{label}</LiquidText>}
                                    </th>
                                    {c === 'valor_jose_tripa' && (
                                        <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}><LiquidText>Outros</LiquidText><br /><LiquidText>Valores</LiquidText></th>
                                    )}
                                    {c === 'kms' && (
                                        <>
                                        <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}><LiquidText>Total</LiquidText><br /><LiquidText>Pago</LiquidText></th>
                                        <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}><span className="rh-recibo-cabecalho" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}><span><LiquidText>Recibo</LiquidText><br /><LiquidText>Vencimento</LiquidText></span><BotaoEmailRecibo titulo="Enviar os recibos do mês a todos os trabalhadores" disabled={loading || !!pedidoEmail || !linhas.length} onClick={() => setPedidoEmail({ periodo, ids: linhas.map(l => l.trabalhador_id) })} /></span></th>
                                        </>
                                    )}
                                    </React.Fragment>
                                ))}
                                <th style={{ textAlign: 'center' }}><LiquidText>Observações</LiquidText></th>
                            </tr>
                        </thead>
                        <tbody>
                            {lista.map(l => (
                                <tr key={l.trabalhador_id} data-jt-inferior={jtInferior(l) ? 'true' : undefined}
                                    title={jtInferior(l) ? 'Valores José Tripa inferior à Simulação Fiscomapa' : undefined}
                                    style={{ background: jtInferior(l) ? '#fee2e2' : alterado(l) ? '#fffbeb' : undefined }}>
                                    <td className="rh-vencimento-nome" style={{ fontWeight: 600, whiteSpace: 'nowrap', textAlign: 'left' }}>
                                        {l.tem_teto && (
                                            <button type="button" className="rh-recalcular-indicador" onClick={() => recalcularTeto(l)}
                                                disabled={saving > 0 || recalculando != null || alterado(l)}
                                                title="RECALCULAR" aria-label={'Recalcular ' + l.nome}
                                                aria-busy={recalculando === l.trabalhador_id}>
                                                R
                                            </button>
                                        )}
                                        {l.nome}
                                    </td>
                                    {CAMPOS_VENC.map(([c]) => (
                                        <React.Fragment key={c}>
                                        <td style={{ textAlign: 'center' }}>
                                            {c === 'kms' ? (
                                                <input type="text" readOnly aria-label={`Kms de ${l.nome}`} title="Valor p/ Kms ÷ 0,40 €"
                                                    value={val(l, 'valor_kms') === '' || Number(val(l, 'valor_kms')) === 0 ? '' : (Math.round(Number(val(l, 'valor_kms')) * 100) / 40).toLocaleString('de-DE', { useGrouping: true, maximumFractionDigits: 0 })}
                                                    placeholder="" style={{ ...inp, width: 95, textAlign: 'center', background: '#f1f5f9' }} />
                                            ) : c === 'valor_kms' ? (
                                                <input type="text" readOnly aria-label={'Valor p/ Kms de ' + l.nome}
                                                    value={val(l, c) === '' || Number(val(l, c)) === 0 ? '' : formatoMoedaVenc.format(Number(val(l, c)))}
                                                    style={{ ...inp, width: 120, textAlign: 'center', background: '#f1f5f9' }} />
                                            ) : (
                                                <ValorMonetarioVenc label={`${CAMPOS_VENC.find(([key]) => key === c)[1]} de ${l.nome}`}
                                                    value={val(l, c)} disabled={saving > 0 || (c === 'valor_jose_tripa' && !podeEditarJoseTripa(l))}
                                                    restrito={c === 'valor_jose_tripa' && !podeEditarJoseTripa(l)}
                                                    onChange={v => set(l, c, v)} />
                                            )}
                                        </td>
                                        {/* Outros Valores (euros; coluna valor_roupa): só para quem a tem (tem_roupa). */}
                                        {c === 'kms' && (
                                            <>
                                            <td style={{ textAlign: 'center' }}>
                                                <input type="text" readOnly className="rh-total-pago" aria-label={'Total pago de ' + l.nome}
                                                    title={l.tem_teto ? 'Simulação Fiscomapa + Valores José Tripa + Outros Valores' : 'Valores José Tripa'}
                                                    value={totalPago(l) === '' || Number(totalPago(l)) === 0 ? '' : formatoMoedaVenc.format(Number(totalPago(l)))}
                                                    style={{ ...inp, width: 120, textAlign: 'center', color: '#b91c1c', fontWeight: 600 }} />
                                            </td>
                                            {/* Recibo de vencimento do mês: anexar, abrir e apagar. */}
                                            <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                <div className="rh-recibo-controlos">
                                                {(recibos[l.trabalhador_id] || []).map(a => (
                                                    <span key={a.id} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginRight: 4 }}>
                                                        <button type="button" onClick={() => abrirRecibo(a)} title={a.nome_original || 'Abrir recibo'}
                                                            style={{ border: '1px solid #bbf7d0', background: '#f0fdf4', color: '#166534', borderRadius: 6, padding: '3px 8px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                                                            📄 Ver
                                                        </button>
                                                        <button type="button" onClick={() => apagarRecibo(a)} title="Apagar o recibo"
                                                            style={{ border: 0, background: 'none', color: '#b91c1c', cursor: 'pointer', fontSize: 13, lineHeight: 1 }}>✕</button>
                                                    </span>
                                                ))}
                                                <button type="button" className="rh-recibo-anexar" disabled={reciboOcupado != null}
                                                    onClick={() => { setReciboPara(l.trabalhador_id); inputRecibo.current?.click(); }}
                                                    title="Anexar o recibo de vencimento deste mês"
                                                    aria-label={reciboOcupado === l.trabalhador_id ? 'A anexar recibo de vencimento' : 'Anexar recibo de vencimento de ' + l.nome}
                                                    style={{ border: '1px solid #cbd5e1', background: '#fff', color: '#334155', borderRadius: 6, padding: '3px 8px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                                                    <span aria-hidden="true" style={{ fontSize: 18, lineHeight: 1 }}>{reciboOcupado === l.trabalhador_id ? '⏳' : '📄'}</span>
                                                </button>
                                                <BotaoEmailRecibo titulo={'Enviar recibo por e-mail a ' + l.nome} disabled={!!pedidoEmail || reciboOcupado != null || !(recibos[l.trabalhador_id] || []).length} onClick={() => setPedidoEmail({ periodo, ids: [l.trabalhador_id] })} />
                                                </div>
                                            </td>
                                            </>
                                        )}
                                        {c === 'valor_jose_tripa' && (
                                            <td style={{ textAlign: 'center' }}>
                                                {/* Só leitura: é o excesso calculado sobre o teto, não se escreve à mão. */}
                                                {l.tem_roupa && (
                                                    <input type="text" readOnly aria-label={'Outros Valores de ' + l.nome}
                                                        title="Calculado pelo botão Recalcular: o que passa do teto dos 920,00 €"
                                                        value={!tetoEmVigor(l) || l.valor_roupa == null ? '' : formatoMoedaVenc.format(Number(l.valor_roupa))}
                                                        style={{ ...inp, width: 120, textAlign: 'center', background: '#f1f5f9' }} />
                                                )}
                                            </td>
                                        )}
                                        </React.Fragment>
                                    ))}
                                    <td style={{ textAlign: 'center' }}>
                                        <input disabled={saving > 0} maxLength={500} value={val(l, 'observacoes')} onChange={e => set(l, 'observacoes', e.target.value)} onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); }} placeholder="" style={{ ...inp, width: '100%', textAlign: 'center' }} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        {/* Totalizadores das linhas visíveis na lista. */}
                        <tfoot>
                            <tr>
                                <td />
                                <td />
                                <td style={{ textAlign: 'center' }}>
                                    <input type="text" readOnly className="rh-total-pago rh-total-pago-soma"
                                        aria-label="Soma de Valores José Tripa"
                                        title="Soma de Valores José Tripa, acrescida da Simulação Fiscomapa exclusivamente de Francisco José de Mendonça e Silva Ramos e José Manuel Tripa (linhas visíveis)"
                                        value={formatoMoedaVenc.format(lista.reduce((soma, l) => soma + Math.round((Number(val(l, 'valor_jose_tripa')) || 0) * 100) + ([1, 10].includes(Number(l.trabalhador_id)) ? Math.round((Number(val(l, 'simulacao_fiscomapa')) || 0) * 100) : 0), 0) / 100)}
                                        style={{ ...inp, width: 120, textAlign: 'center' }} />
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <input type="text" readOnly className="rh-total-pago rh-total-pago-soma" aria-label="Soma de Outros Valores"
                                        value={formatoMoedaVenc.format(lista.reduce((soma, l) => soma + (l.tem_roupa && tetoEmVigor(l) ? Math.round((Number(l.valor_roupa) || 0) * 100) : 0), 0) / 100)}
                                        style={{ ...inp, width: 120, textAlign: 'center' }} />
                                </td>
                                <td />
                                <td />
                                <td style={{ textAlign: 'center' }}>
                                    <input type="text" readOnly className="rh-total-pago rh-total-pago-soma" aria-label="Soma do Total Pago"
                                        value={formatoMoedaVenc.format(lista.reduce((soma, l) => soma + (Number(totalPago(l)) || 0), 0))}
                                        style={{ ...inp, width: 140, textAlign: 'center', color: '#b91c1c' }} />
                                </td>
                                <td />
                                <td />
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}
        </div>
    );
}

/* ---------- Página: separadores ---------- */
const SEPARADORES = [
    { key: 'trabalhadores', label: '👷 Trabalhadores' },
    { key: 'ferias', label: '🌴 Mapa de Férias' },
    { key: 'horas', label: '⏱️ Registo de Horas' },
    { key: 'vencimentos', label: '💶 Vencimentos' },
];

const RecursosHumanosPage = () => {
    const [acoesTrabalhadoresDestino, setAcoesTrabalhadoresDestino] = useState(null);
    const [filtrosDestino, setFiltrosDestino] = useState(null);
    const [acoesDestino, setAcoesDestino] = useState(null);
    const [controlosDestino, setControlosDestino] = useState(null);
    const [gravarDestino, setGravarDestino] = useState(null);
    const { user, hasPermission } = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const separadores = SEPARADORES.filter(s => s.key === 'trabalhadores'
        ? hasPermission('trabalhadores')
        : hasPermission('recursos-humanos') && (s.key !== 'vencimentos' || user?.role === 'admin'));
    const solicitado = searchParams.get('separador') || 'trabalhadores';
    const sep = separadores.some(s => s.key === solicitado) ? solicitado : separadores[0]?.key;
    const escolher = k => {
        const params = new URLSearchParams(searchParams);
        params.set('separador', k);
        setSearchParams(params);
    };
    if (!sep) return <div className="page-content">Não tem permissão para aceder a esta área.</div>;
    return (
        <div className="rh-page" data-rh-separador={sep}>
            <div className="top-bar rh-cabecalho-painel"><div className="rh-titulo-linha"><div className="top-bar-title"><h1>Recursos Humanos - {sep === 'trabalhadores' ? 'Trabalhadores' : sep === 'horas' ? 'Registo de Horas' : sep === 'vencimentos' ? 'Vencimentos' : 'Mapa de Férias'}</h1></div><div className="rh-gravar-destino" ref={setGravarDestino} hidden={sep !== 'vencimentos'} /></div>
            <div className="rh-navegacao-linha">
            <div className="liquid-rh-tabs" style={{ display: 'flex', gap: 4, padding: '14px 24px 0', borderBottom: '1px solid #e2e8f0', background: '#fff' }}>
                {separadores.map(s => (
                    <button aria-pressed={sep === s.key} key={s.key} onClick={() => escolher(s.key)} style={{
                        padding: '10px 16px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '0.92rem',
                        borderBottom: sep === s.key ? '3px solid #3182ce' : '3px solid transparent',
                        fontWeight: sep === s.key ? 700 : 500, color: sep === s.key ? '#1e40af' : '#475569',
                    }}><LiquidText>{s.label}</LiquidText></button>
                ))}
            </div>
                <div className="rh-trabalhadores-acoes-linha" ref={setAcoesTrabalhadoresDestino} hidden={sep !== 'trabalhadores'} />
                <div className="rh-extra-filtros" ref={setFiltrosDestino} hidden={sep === 'vencimentos' || sep === 'trabalhadores'} />
                <div className="rh-vencimentos-controlos" ref={setControlosDestino} hidden={sep !== 'vencimentos'} />
            </div>
            <div className="rh-extra-acoes" ref={setAcoesDestino} hidden={sep === 'vencimentos' || sep === 'trabalhadores'} />
            </div>
            {sep === 'trabalhadores' && <Trabalhadores integrado acoesDestino={acoesTrabalhadoresDestino} />}
            {sep === 'ferias' && <RecursosHumanos filtrosDestino={filtrosDestino} acoesDestino={acoesDestino} />}
            {sep === 'horas' && <div className="page-content" style={{ padding: 24 }}><RegistoHorasRH filtrosDestino={filtrosDestino} acoesDestino={acoesDestino} /></div>}
            {sep === 'vencimentos' && <div className="page-content" style={{ padding: 24 }}><Vencimentos controlosDestino={controlosDestino} gravarDestino={gravarDestino} /></div>}
        </div>
    );
};

/* ---------- estilos ---------- */
const lbl = { display: 'block', fontSize: '0.72rem', color: '#64748b', fontWeight: 600, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.03em' };
const inp = { padding: '7px 10px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: '0.9rem', boxSizing: 'border-box' };
const badge = { padding: '3px 10px', borderRadius: 12, fontSize: '0.76rem', fontWeight: 600, whiteSpace: 'nowrap' };
const btnSec = { padding: '7px 14px', border: '1px solid #cbd5e1', background: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem', color: '#334155' };
const btnAtivo = { background: '#3182ce', color: '#fff', borderColor: '#3182ce' };
const btnPri = { padding: '7px 14px', border: '1px solid #3182ce', background: '#3182ce', color: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem' };
const thSticky = { position: 'sticky', left: 0, background: '#f8fafc', zIndex: 2, textAlign: 'left', padding: '6px 10px', borderBottom: '1px solid #e2e8f0', borderRight: '2px solid #cbd5e1', fontSize: '0.78rem', color: '#334155' };
const tdSticky = { position: 'sticky', left: 0, background: '#fff', zIndex: 1, padding: '4px 10px', borderRight: '2px solid #cbd5e1', borderBottom: '1px solid #f1f5f9', whiteSpace: 'nowrap', fontSize: '0.8rem' };
const overlay = { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, padding: '40px 16px', overflowY: 'auto' };
const modal = { background: '#fff', borderRadius: 14, padding: 22, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' };
const modalHead = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 };
const closeBtn = { border: 'none', background: 'transparent', fontSize: '1.2rem', cursor: 'pointer', color: '#64748b' };
const grid2 = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 };

export default RecursosHumanosPage;
